import { deepEquals } from 'app/infrastructure/js';
import { linkCodesAction } from '../constants';
import { ListAction } from '../types-store';

export const appendAction = (allActions: ListAction[], currentAction: ListAction) => {

  if (!currentAction) {
    return allActions ?? [];
  }

  if (currentAction.type === linkCodesAction.selectAll ||
    currentAction.type === linkCodesAction.deselectAll ||
    (allActions?.length ?? 0) === 0) {

    return [currentAction];
  }

  let isDuplicate = false;

  for (const action of [...allActions].reverse()) {

    if (action.type === linkCodesAction.selectAll ||
      action.type === linkCodesAction.deselectAll) {

      isDuplicate = (action.type === linkCodesAction.selectAll &&
        currentAction.type === linkCodesAction.select) ||
        (action.type === linkCodesAction.deselectAll &&
          currentAction.type === linkCodesAction.deselect);
      break;
    }

    if (action.type === linkCodesAction.select &&
      currentAction.type === linkCodesAction.deselect &&
      deepEquals(currentAction.path, action.path.slice(0, currentAction.path.length))) {

      break;
    }

    if (deepEquals(action.path, currentAction.path.slice(0, action.path.length))) {

      if (action.propagate ||
        (!currentAction.propagate && deepEquals(action.path, currentAction.path))) {

        isDuplicate = action.type === currentAction.type;
        break;
      }
    }
  }

  if (isDuplicate) {
    return allActions;
  }

  const filteredActions = allActions.filter(action => {

    if (action.type === linkCodesAction.selectAll ||
      action.type === linkCodesAction.deselectAll ||
      !deepEquals(currentAction.path, action.path.slice(0, currentAction.path.length))) {
      return true;
    }

    const overwritesChildren = currentAction.propagate ||
      (!action.propagate && deepEquals(currentAction.path, action.path));

    const overwritesParents = action.type === currentAction.type ||
      action.type !== linkCodesAction.select ||
      currentAction.path.length === 1;

    return !(overwritesChildren && overwritesParents);
  });

  return [
    ...filteredActions,
    currentAction
  ];
};
